import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  proxyCartao: Yup.string().required('Este campo é obrigatório'),
  packageId: Yup.number().min(1, 'O Valor do pacote deve ser maior que 0').required('Este campo é obrigatório'),
});

export default validationSchema;
